// extracted by css-extract-rspack-plugin
export default {"artifact":"artifact--Zyb3i3SIiMIapS1F","emptyArtifacts":"empty-artifacts--UPtZXIs67jASZciD","emptyImage":"empty-image--SMbvEIm1hKIwZPaB"};